"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _redux = require("redux");

var _reducers = _interopRequireDefault(require("./activities/reducers"));

var _reducers2 = _interopRequireDefault(require("./apps/reducers"));

var _reducers3 = _interopRequireDefault(require("./challenges/reducers"));

var _reducers4 = _interopRequireDefault(require("./clients/reducers"));

var _reducers5 = _interopRequireDefault(require("./feed/reducers"));

var _reducers6 = _interopRequireDefault(require("./info/reducers"));

var _reducers7 = _interopRequireDefault(require("./core/reducers"));

var _reducers8 = _interopRequireDefault(require("./rewards/reducers"));

var _default = (0, _redux.combineReducers)({
  activities: _reducers["default"],
  apps: _reducers2["default"],
  challenges: _reducers3["default"],
  clients: _reducers4["default"],
  feed: _reducers5["default"],
  info: _reducers6["default"],
  core: _reducers7["default"],
  rewards: _reducers8["default"]
});

exports["default"] = _default;
//# sourceMappingURL=reducers.js.map